import { AdvanceTable, IBasicTableColumn } from 'ui-lib';
import * as React from 'react';
import { IDeviceTableProps } from './components';
import { useDeviceStore } from 'store';
import devicesCss from './devices.css';
import { EffectiveDeploymentDto } from 'dto/raptor-device.dto';
import { TableUtils } from 'pages/private/components/table-utils';
import { useLoadingStates } from 'hooks/use-loading.hook';
import { MessagesAlert } from 'pages/private/components/alert/messages-alert';

export const RaptorDeploymentsTable = (props: IDeviceTableProps) => {
    const loadingStates = useLoadingStates();
    const [effectiveDeployments, setEffectiveDeployments] = React.useState<EffectiveDeploymentDto[]>([]);
    const devicesStore = useDeviceStore();

    const loadDeployments = async () => {
        return loadingStates.withLoading(async () => {
            const result = await devicesStore.getEffectiveDeployments(props.accountId, props.uid);
            setEffectiveDeployments(result);
        });
    };

    React.useEffect(() => {
        loadDeployments();
    }, []);

    const columns: IBasicTableColumn[] = [
        TableUtils.createBasicFilterColumn({
            key: 'deploymentName',
            title: 'Deployment Name',
        }),
        TableUtils.createBasicFilterColumn({
            key: 'coreDeviceExecutionStatus',
            title: 'Status',
        }),
        TableUtils.createBasicFilterTimeColumn({
            key: 'creationTimestamp',
            title: 'Created At',
        }),
        TableUtils.createBasicFilterTimeColumn({
            key: 'modifiedTimestamp',
            title: 'Modified At',
            defaultSortOrder: 'descend'
        }),
    ];

    return (
        <div className={devicesCss.tabPane}>
            <MessagesAlert errorMessages={loadingStates.errorMessages} />
            <AdvanceTable
                title=''
                table={{
                    rowKey: 'deploymentId',
                    dataSource: effectiveDeployments,
                    columns: columns,
                }}
                loadingState={loadingStates.loading}
                toolbar={{
                    onReload: () => loadDeployments(),
                }}
            />
        </div>
    );
};
